import { TMessageListFileType } from '@cian/chats-api';
import { IconActionBlock16, IconFileDocument16, IconMediaPhoto16 } from '@cian/ui-kit-design-tokens/icons';
import classnames from 'clsx';
import * as React from 'react';

import * as styles from '../../ChatListItem.css';

import advertImg from '../../assets/advert.svg';

type TLastMessageContentProps = {
  name?: string;
  message: string;
  multiline: boolean;
  file?: { type: TMessageListFileType; name: string };
  isOffer?: boolean;
  deleted?: boolean;
};

const CHAT_LIST_FILE_ICON = {
  image: <IconMediaPhoto16 />,
  imageAsDocument: <IconFileDocument16 />,
  document: <IconFileDocument16 />,
};

export const LastMessageContent: React.FC<TLastMessageContentProps> = ({
  name,
  message,
  multiline,
  file,
  isOffer,
  deleted,
}) => {
  return (
    <span className={styles['message']}>
      {name && <span className={styles['name']}>{name}</span>}

      {!deleted && file && (
        <>
          {CHAT_LIST_FILE_ICON[file.type ? file.type : 'document']}
          <span className={styles['text']}>{file.type === 'image' ? 'Фото' : file.name}</span>
        </>
      )}

      {!deleted && isOffer && (
        <>
          <img src={advertImg} width={16} height={16} />
          <span className={styles['text']}>Объявление</span>
        </>
      )}

      {((!file && !isOffer) || deleted) && (
        <>
          {deleted && <IconActionBlock16 color="icon-secondary-default" />}
          <span className={classnames(styles['text'], multiline && styles['multiline'])}>{message}</span>
        </>
      )}
    </span>
  );
};
